"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/HNFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_102)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_102`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V8H-6V0ZM-6 16H30V24H-6V16ZM8.2807 8.27368L8.75088 9.4386L9.98596 9.50877L9.00351 10.2737L9.33333 11.5158L8.2807 10.8211L7.22807 11.5158L7.55789 10.2737L6.57544 9.50877L7.81053 9.4386L8.2807 8.27368ZM15.6491 8.27368L16.1193 9.4386L17.3544 9.50877L16.3719 10.2737L16.7018 11.5158L15.6491 10.8211L14.5965 11.5158L14.9263 10.2737L13.9439 9.50877L15.1789 9.4386L15.6491 8.27368ZM11.9649 10.3579L12.4351 11.5228L13.6702 11.593L12.6877 12.3579L13.0175 13.6L11.9649 12.9053L10.9123 13.6L11.2421 12.3579L10.2596 11.593L11.4947 11.5228L11.9649 10.3579ZM8.2807 12.4421L8.75088 13.607L9.98596 13.6772L9.00351 14.4421L9.33333 15.6772L8.2807 14.9825L7.22807 15.6772L7.55789 14.4421L6.57544 13.6772L7.81053 13.607L8.2807 12.4421ZM15.6491 12.4421L16.1193 13.607L17.3544 13.6772L16.3719 14.4421L16.7018 15.6772L15.6491 14.9825L14.5965 15.6772L14.9263 14.4421L13.9439 13.6772L15.1789 13.607L15.6491 12.4421Z",
					fill: "#338AF3"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_102`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as HNFlag };
